<template>
    <div class="text-center">
      <v-dialog v-model="dialog" max-width="700" persistent>
        <v-card>
          <v-card-title class="text-h5 blue darken-3 white--text">
            Aprobar o rechazar la fecha de campaña
          </v-card-title>
   
          <v-card-text>  
            <h5 class="text-center"> {{ dato.nombre_proyecto }} </h5>
            <p class="text-center"> {{ dato.sede_portal_name }} </p>
            <div class="text-center" v-show="unidad_id!=1">
              <p class="mb-0 green--text">Periodo de registro del programa en el portal ESAM:</p>
              <b>del:</b> {{ parseDateFecha(reg_prog.fecha_inicio) }}
              <b>al:</b> {{ parseDateFecha(reg_prog.fecha_final) }} 
            </div>
            <hr class="mt-1 mb-1"/>
            <div class="text-center">
              <p class="mb-0 green--text">Periodo de campaña:</p>
              <v-badge v-if="ultima.estado=='solicitado'" dot color="orange" />
              <v-badge v-else-if="ultima.estado=='aprobado'" dot color="green" />
              <v-badge v-else-if="ultima.estado=='rechazado'" dot color="red" />
              <v-badge v-else-if="ultima.estado=='reprogramado'" dot color="purple" />
              &nbsp;
              <b>desde:</b> {{ parseDateFecha(ultima.fecha_inicio) }}
              <b>al:</b> {{ parseDateFecha(ultima.fecha_final) }}
              <p>
                <b>Tipo de solicitud: </b>{{ ultima.estado }}
              </p>
            </div> 
            <v-progress-linear v-if="loading" class="mt-2" indeterminate/>
          </v-card-text>
  
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green" :disabled="loading" outlined @click="aprobar()"> Aprobar </v-btn>
            <v-btn color="red" :disabled="loading" outlined @click="desaprobar()"> Rechazar </v-btn>
            <v-btn color="orange" outlined class="ml-8" @click="dialog = false"> Cerrar </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
</template>
  
<script>
import { parseDateFecha} from '../util.ts'
import { responder_fecha_campania } from '../servicios/seleccionService.ts';

export default {
    data() {
        return {
            parseDateFecha,
            loading: false,
            dialog: false,
            dato: {},
            ultima:{},
            reg_prog:{},
            input: {},
            unidad_id: null,
        };
    },
    methods: {
        async openmodal(row) {
            // window.console.log('>>><<<<<<',row);
            const user = this.$store.state.DATA_USER
            this.dato = row
            this.ultima = row.ultima_campania
            this.reg_prog = row.ultima_reg_prog? row.ultima_reg_prog: {};
            this.input = {
                id: this.ultima.id,
                respondido_por_id: user.id
            }
            // window.console.log('>>>',row,sede,user);
            this.unidad_id = this.$store.state.CARGO.sede.unidad_negocio
            this.dialog = true
        }, 

        async aprobar(){ 
            this.input.estado = "aprobado";
            this.enviar();
        },

        async desaprobar(){
            this.input.estado = "rechazado";
            this.enviar();
        },

        async enviar(){
            this.loading = true
            const r = await responder_fecha_campania(this.input)
            window.console.log('>>><<<<<<',r);
            
            if(r && r.responder_fecha_campania){ 
              this.$root.$notify.show(this.input.estado, { color: '#009800', x: 'left' });
              this.dialog = false
              this.dato.ultima_campania.estado = r.responder_fecha_campania.estado
              this.dato.ultima_campania.respondido_por_id = r.responder_fecha_campania.respondido_por_id 
            }else if(r && r.graphQLErrors) {
              let m = ''
              r.graphQLErrors.forEach(x => m += x.message);  
              this.$root.$notify.show(m, { color: '#980000', x: 'left' });
            }else{
              const m = JSON.stringify(r);
              this.$root.$notify.show(m, { color: '#980000', x: 'left' });
            }
            
            this.loading = false
        }
    }
};
</script>
  